const ProjectileNames = {
  ARROW: "ARROW",
  POISON_ARROW: "POISON_ARROW",
  GLUE_ARROW: "GLUE_ARROW",
  BOMB_ARROW: "BOMB_ARROW",
};

export default ProjectileNames;
